import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { Grid } from '@softwaredev_cegeka/stix-core'
import { NotifierContainer } from '@softwaredev_cegeka/stix-notifier'

import { ContentRoute } from 'src/routes/ContentRoute'
import { Header } from 'src/components/Header'
import ErrorBoundary from 'src/components/ErrorBoundary'
import { Sidebar } from 'src/components/Sidebar'
import withUserData from 'src/components/auth/withUserData'
import InternalServerError from './InternalServerError'
import NotFound from './NotFound'
import { routeConfig } from './config'

const { Col, Row } = Grid

class Main extends React.Component {
    render() {
        return (
            <>
                <NotifierContainer
                    position={'fixed'}
                    defaults={{
                        autohide: true,
                        delay: 5000,
                    }}
                />
                <Header />
                <Grid.Container fluid>
                    <Row>
                        <Col md={3} className="layout-side">
                            <Sidebar />
                        </Col>
                        <Col md={9} className="layout-main">
                            <Switch>
                                {/*this needs to be outside because we redirect to it from the ErrorBoundary*/}
                                <Route
                                    exact
                                    path={'/internal-error'}
                                    component={InternalServerError}
                                />
                                <Route>
                                    <ErrorBoundary>
                                        <Switch>
                                            {routeConfig.map((route, index) => {
                                                if (
                                                    route.permissions instanceof
                                                    Function
                                                ) {
                                                    if (
                                                        !route.permissions(
                                                            this.props.userData
                                                        )
                                                    ) {
                                                        return null
                                                    }
                                                }
                                                return (
                                                    <ContentRoute
                                                        key={index}
                                                        match={this.props.match}
                                                        path={route.path}
                                                        component={
                                                            route.component
                                                        }
                                                        title={route.title}
                                                        name={route.name}
                                                        breadcrumbs={
                                                            route.breadcrumbs
                                                        }
                                                    />
                                                )
                                            })}
                                            <Route component={NotFound} />
                                        </Switch>
                                    </ErrorBoundary>
                                </Route>
                            </Switch>
                        </Col>
                    </Row>
                </Grid.Container>
            </>
        )
    }
}

export default withUserData(Main)
